import * as React from "react";
import { SVGProps, memo } from "react";

const SvgDummy = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M31.667 5H8.333A3.343 3.343 0 0 0 5 8.333v23.334C5 33.5 6.5 35 8.333 35h23.334C33.5 35 35 33.5 35 31.667V8.333C35 6.5 33.5 5 31.667 5Zm0 26.667H8.333V8.333h23.334v23.334Zm-8.4-11.184-4.584 5.9-3.266-3.933-4.584 5.883h18.334l-5.9-7.85Z"
      fill="#272C33"
    />
  </svg>
);

const Memo = memo(SvgDummy);

export default Memo;
